import { serverTimestamp, type FieldValue } from 'firebase/firestore'
import {
  typedCollection,
  typedDoc,
  getCollection,
  updateDocument,
  deleteDocument,
  addDoc,
  orderBy,
} from '@/lib/firebase/firestore'
import type { SeasonDocument } from '@/types'
import type { SeasonFormValues } from '../types'

const seasonsCol = () => typedCollection<SeasonDocument>('seasons')

type SeasonCreatePayload = Omit<SeasonDocument, 'id' | 'createdAt' | 'updatedAt'> & {
  createdAt: FieldValue
  updatedAt: FieldValue
}

export const adminSeasonsService = {
  async createSeason(data: SeasonFormValues): Promise<string> {
    const payload: SeasonCreatePayload = {
      number: data.number,
      title: data.title,
      description: data.description,
      year: data.year,
      isPublished: data.isPublished,
      order: data.order,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    }
    const ref = await addDoc(seasonsCol(), payload as unknown as SeasonDocument)
    return ref.id
  },

  async updateSeason(id: string, data: Partial<SeasonFormValues>): Promise<void> {
    const ref = typedDoc<SeasonDocument>('seasons', id)
    await updateDocument(ref, {
      ...data,
      updatedAt: serverTimestamp(),
    })
  },

  async deleteSeason(id: string): Promise<void> {
    const ref = typedDoc<SeasonDocument>('seasons', id)
    await deleteDocument(ref)
  },

  async getAllSeasons(): Promise<Array<SeasonDocument & { id: string }>> {
    return getCollection(seasonsCol(), orderBy('order', 'asc'))
  },
}
